import React, { FC } from 'react';
import { getProductionBatchByProductionOperationId, operationsSearch } from '@reducers/search';
import { updateHeaderConfig } from '@reducers/details';
import { connect } from 'react-redux';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { NCFileSearchItem } from '@interfaces/search';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useJobDetails } from '@v2/pages/common/hooks/useJobDetails';
import { getNCFilesByProductionOperationId } from '@reducers/manufacture';
import NCFileListOrSingleItem from '@v2/pages/machines/modules/now/components/NC-file/components/NCFileListOrSingleItem';
import NcFileVersions from '@components/ncFileVersions';
import JobContentWrapper from '@v2/pages/job/common/components/JobContentWrapper';

interface JobDetailsNCFileVersionsProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const JobDetailsNCFileVersionsComponent: FC<JobDetailsNCFileVersionsProps> = ({
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
  ncFileData,
}) => {
  const title = useTitle();

  useJobDetails({
    updateHeaderConfig,
    operationsSearch,
    getNCFilesByProductionOperationId,
    getProductionBatchByProductionOperationId,
    getAllNcFiles: true,
  });

  return (
    <JobContentWrapper loading={false} title={title.ncFile}>
      <NcFileVersions ncFile={ncFileData.data} loaded={ncFileData.wasLoaded} />
    </JobContentWrapper>
  );
};

const JobDetailsNCFileVersions = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  updateHeaderConfig,
  operationsSearch,
  getNCFilesByProductionOperationId,
  getProductionBatchByProductionOperationId,
})(JobDetailsNCFileVersionsComponent);

export { JobDetailsNCFileVersions };
